<template>
    <div>
        <CRow class="paySlipText">
            <CCol sm="8">
                <h1>Claim a Reimbursement</h1>
                <CCol sm="8">
                    Type of reimbursement?
                    <select class="selectClass">
                        <option>2021-2022</option>
                        <option>2020-2021</option>
                        <option>2019-2020</option>
                        <option>2018-2019</option>
                        <option>2017-2018</option>
                    </select>
                    <CInput
                        label="Expense Date"
                        type="date"
                        placeholder="Enter your company PAN number"
                    />
                    <CInput label="Any detail?" placeholder="" />
                    <CInput label="Amount" placeholder="" />
                    <!-- <CInput
                        label="Supporting images or documents (maximum 5 MB
                    each)"
                        addLabelClasses="fileUploadLabel"
                        type="file"
                        placeholder=""
                        class="fileUpload"
                    /> -->
                </CCol>
                <CCol>
                    <CButton size="sm" class="buttonSize">
                        REQUEST REIMBURSEMENT
                    </CButton>
                </CCol>
            </CCol>
        </CRow>
    </div>
</template>

<script>
export default {
    data() {
        return {
            fromDateVal: null,
            showPicker: false,
            selectedDate: null,
            minDate: '2019-07-04',
            maxDate: '2019-08-30'
        };
    },
    computed: {
        fromDateDisp() {
            return this.fromDateVal;
            // format date, apply validations, etc. Example below.
            // return this.fromDateVal ? this.formatDate(this.fromDateVal) : "";
        }
    }
};
</script>
<style scoped>
.buttonSize {
    height: 50px;
    padding: 10px 40px;
    background-color: #5a99e8;
    color: white;
}
.selectClass {
    width: 100%;
    color: white;
    background-color: #272f51;
    padding: 10px;
    margin-bottom: 20px;
    margin-top: 10px;
}
.fileUpload {
    margin-bottom: 10px;
    color: white;
}
</style>
